import { forwardRef } from 'react';
import { Link, type LinkProps } from 'react-router';

/**
 * Standard router link wrapper designed to be passed to Material-UI components
 * via the component prop. Maps the `href` prop to `to`.
 */
export const LinkBehavior = forwardRef<
    HTMLAnchorElement,
    Omit<LinkProps, 'to'> & { href: LinkProps['to'] }
>(({ href, ...rest }, ref) => <Link ref={ref} to={href} {...rest} />);
